import {
  BillLineInstallmentStatus,
  BillLineInstallmentV2,
  BillLIneItemGroup,
  BillLineItemV2Kind,
  BillList,
  BillListResponseV3,
  BillRawV3,
} from '@types'

function getNextAmountBalance(nextBill: BillRawV3) {
  const lineItemBalance: any[] = []

  nextBill.line_item_groups.forEach(({ line_items }) => {
    const lineItemsWithBalance = line_items.filter((lineItem) => {
      return lineItem.kind === BillLineItemV2Kind.Balance
    })

    if (lineItemsWithBalance.length) {
      lineItemBalance.push(lineItemsWithBalance[0])
    }
  })

  return lineItemBalance.length ? lineItemBalance[0]['amount_cents'] : 0
}

export function transformLineItemInstallment(
  lineItemInstallment: BillLineInstallmentV2
): any {
  const {
    metadata: { versions },
  } = lineItemInstallment
  const lineItemInstallmentCopy = JSON.parse(
    JSON.stringify(lineItemInstallment)
  )
  const version = versions[versions.length - 1]

  const isEdited = versions.length > 1
  const isCanceled =
    version?.installment_internal_status === BillLineInstallmentStatus.Canceled
  const isReimbursed =
    version?.installment_internal_status ===
    BillLineInstallmentStatus.Reimbursed

  lineItemInstallmentCopy.metadata.edition = {
    edited: isEdited,
    canceled: isCanceled,
    reimbursed: isReimbursed,
    lastEditionDate: isEdited ? version?.installment_edited_at : '',
    newAmount: isEdited ? version?.invoice_total_amount_cents : 0,
    originalAmount: isEdited ? versions[0]?.invoice_total_amount_cents : 0,
  }

  return lineItemInstallmentCopy
}

export function transformLineItemGroups(lineItemGroups: BillLIneItemGroup[]) {
  return lineItemGroups.map((lineItemGroup) => {
    const lineItemGroupUpdated = lineItemGroup.line_items.map((lineItem) => {
      if (lineItem.kind === BillLineItemV2Kind.Installment) {
        return transformLineItemInstallment(lineItem)
      }
      return lineItem
    })
    lineItemGroup.line_items = lineItemGroupUpdated
    return lineItemGroup
  })
}

export function billListTransform(response: BillListResponseV3): BillList {
  function updateBills() {
    return response.bills.map((bill, i) => {
      const nextBill = response.bills.at(i + 1)

      return {
        ...bill,
        line_item_groups: transformLineItemGroups(bill.line_item_groups),
        balance: nextBill ? getNextAmountBalance(nextBill) : 0,
      }
    })
  }

  return {
    ...response,
    bills: updateBills(),
  }
}
